import React, { useEffect } from 'react';
import { Field, useFormikContext } from 'formik';
import PropTypes from 'prop-types';

const FieldNumber = ({
  maxLength,
  name,
  placeholder,
  disabled,
  min,
  max,
  label,
  className,
  classInvalid,
  required,
  onChangeCallback,
  type,
  valueDefinied,
  hidden,
}) => {
  const { setFieldValue, values, errors, touched } = useFormikContext();
  const validateOnlyDigits = (value) => (/^\d+$/.test(value));
  const validateMax = (value) => (value.length <= max);
  const validateMin = (value) => (value.length >= min);

  const isValidValue = (value) => {
    let valid = true;
    const validations = [
      { flag: true, validation: validateOnlyDigits },
      { flag: max !== null, validation: validateMax },
      { flag: min !== null, validation: validateMin },
    ];
    validations.forEach((item) => {
      if (item.flag) valid = valid && item.validation(value);
    });
    return valid;
  };

  const onChange = (event) => {
    const { value } = event.target;
    if (isValidValue(value)) {
      setFieldValue(name, value);
      onChangeCallback(value);
    } else {
      setFieldValue(name, value.slice(0, value.length - 1));
    }
  };

  useEffect(() => {
    if (valueDefinied) {
      setFieldValue(name, valueDefinied);
    }
  }, [valueDefinied]);

  return (
    <div className={className} hidden={hidden}>
      {label && (
        <label htmlFor={name}>
          {label}
          {required && <span className="color-red">&nbsp;*</span>}
        </label>
      )}
      {errors[name] && touched[name] && <div className={classInvalid}>{errors[name]}</div>}
      {!errors[name] && touched[name] && <div className="field-valid">ok</div>}
      <Field
        name={name}
        value={values[name] || valueDefinied}
        maxLength={maxLength}
        disabled={disabled}
        type={type}
        placeholder={placeholder}
        onChange={onChange} />
    </div>
  );
};

FieldNumber.defaultProps = {
  required: false,
  maxLength: 255,
  placeholder: '',
  label: '',
  className: 'field -input',
  classInvalid: 'field-invalid',
  max: null,
  min: null,
  type: 'text',
  onChangeCallback: () => { },
  disabled: false,
  valueDefinied: null,
  hidden: false,
};
FieldNumber.propTypes = {
  maxLength: PropTypes.number,
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  max: PropTypes.number,
  min: PropTypes.number,
  label: PropTypes.string,
  className: PropTypes.string,
  required: PropTypes.bool,
  classInvalid: PropTypes.string,
  onChangeCallback: PropTypes.func,
  type: PropTypes.string,
  disabled: PropTypes.bool,
  valueDefinied: PropTypes.number,
  hidden: PropTypes.bool,
};

export default FieldNumber;
